import React, { useState } from "react";
import { navigate } from "gatsby";
import "./BurgerMenu.scss";
import { isContactUsActive } from "../../functions";
import { Link } from "gatsby";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { useScrollLock } from "../../hooks/useScrollLock";
import { normalizeUrl } from "./utils";

const BurgerMenu = ({ nodes, post }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});

  // Utiliser le hook pour bloquer le scroll
  useScrollLock(isOpen);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setExpandedItems({});
  };

  const toggleSubmenu = (itemId, e) => {
    e.stopPropagation();
    setExpandedItems((prev) => {
      // Fermer tous les autres sous-menus
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
      });
      // Ouvrir/fermer le sous-menu cliqué
      newState[itemId] = !prev[itemId];
      return newState;
    });
  };

  const handleMenuItemClick = (url, hasChildren, itemId, e) => {
    if (hasChildren) {
      toggleSubmenu(itemId, e);
    } else {
      closeMenu();
      navigate(normalizeUrl(url));
    }
  };

  return (
    <div className={`burger-menu ${isOpen ? "open" : ""}`}>
      <button
        className={`burger-button ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Menu principal"
      >
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </button>

      <div className={`burger-overlay ${isOpen ? "open" : ""}`}>
        <nav className="burger-nav">
          <ul className="burger-menu-list">
            {nodes &&
              nodes.map((item, key) => (
                <li key={key} className="burger-menu-item">
                  <div className="burger-menu-row">
                    <button
                      onClick={(e) =>
                        handleMenuItemClick(
                          normalizeUrl(item.url),
                          item.children && item.children.length > 0,
                          item.id,
                          e
                        )
                      }
                      className="burger-menu-link"
                    >
                      {item.label}
                    </button>
                    {item.children && item.children.length > 0 && (
                      <button
                        onClick={(e) => toggleSubmenu(item.id, e)}
                        className="burger-toggle"
                        aria-label="Ouvrir le sous-menu"
                      >
                        {expandedItems[item.id] ? "−" : "+"}
                      </button>
                    )}
                  </div>
                  {item.children && item.children.length > 0 && (
                    <ul
                      className={`burger-submenu ${
                        expandedItems[item.id] ? "expanded" : ""
                      }`}
                    >
                      {item.children.map((child, childKey) => (
                        <li key={childKey} className="burger-submenu-item">
                          <button
                            onClick={() =>
                              handleMenuItemClick(
                                normalizeUrl(child.url),
                                false,
                                null
                              )
                            }
                            className="burger-submenu-link"
                          >
                            {child.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
          {!isContactUsActive(post) ? (
            <Link className="call-to-action" to="/contactez-nous">
              <EnvelopeIcon
                style={{
                  width: "18px",
                  transition: "opacity 0.3s ease",
                  marginRight: "8px",
                }}
              />
              Nous contacter
            </Link>
          ) : null}
        </nav>
      </div>
    </div>
  );
};

export default BurgerMenu;
